import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { Stack, Shimmer } from '@fluentui/react';

export const SectionShimmer = ({ count }) => (
  <Stack tokens={{ childrenGap: 16 }}>
    {_.range(count).map(index => (<Shimmer key={index} width={`${100 - ((index % 4) * 25)}%`} />))}
  </Stack>
);

SectionShimmer.propTypes = {
  count: PropTypes.number,
};

SectionShimmer.defaultProps = {
  count: 3,
};
